export class YearModel {
  id?: number;
  year?: number = null;
  editable?: boolean;
}
